import React, { useMemo } from "react";
import Card from "components/ui/Card/Card";
import DataTable, {
  DataTableColumn,
} from "components/ui/DataTable/DataTable";
import { formatCurrency } from "utils/format";
import { formatDateTime } from "utils/dateUtils";
import styles from "./UpayTransactionsPage.module.scss";

type UpayTransaction = {
  id: string;
  dateTime: string;
  accountNo: string;
  debitMsisdn: string;
  creditShortCode: string;
  trxId: string;
  transactionStatus: "Completed" | "Pending" | "Failed" | "Reversed";
  currency: "BDT" | "USD";
  amount: number;
};

const transactions: UpayTransaction[] = [
  {
    id: "1",
    dateTime: "2024-03-01T09:18:00",
    accountNo: "AC-10100",
    debitMsisdn: "01811000111",
    creditShortCode: "UATM01",
    trxId: "UP20240301001",
    transactionStatus: "Completed",
    currency: "BDT",
    amount: 2200,
  },
  {
    id: "2",
    dateTime: "2024-03-01T10:55:00",
    accountNo: "AC-10102",
    debitMsisdn: "01812000222",
    creditShortCode: "UATM01",
    trxId: "UP20240301055",
    transactionStatus: "Completed",
    currency: "BDT",
    amount: 1650,
  },
  {
    id: "3",
    dateTime: "2024-03-02T08:05:00",
    accountNo: "AC-10103",
    debitMsisdn: "01813000333",
    creditShortCode: "UATM01",
    trxId: "UP20240302008",
    transactionStatus: "Pending",
    currency: "BDT",
    amount: 1980,
  },
  {
    id: "4",
    dateTime: "2024-03-03T11:14:00",
    accountNo: "AC-10104",
    debitMsisdn: "01814000444",
    creditShortCode: "UATM01",
    trxId: "UP20240303114",
    transactionStatus: "Failed",
    currency: "BDT",
    amount: 2400,
  },
  {
    id: "5",
    dateTime: "2024-03-03T15:42:00",
    accountNo: "AC-10105",
    debitMsisdn: "01815000555",
    creditShortCode: "UATM01",
    trxId: "UP20240303142",
    transactionStatus: "Reversed",
    currency: "BDT",
    amount: 1800,
  },
];

function UpayTransactionsPage() {
  const columns = useMemo<DataTableColumn<UpayTransaction>[]>(
    () => [
      {
        id: "dateTime",
        header: "Date Time",
        accessorKey: "dateTime",
        filter: {
          type: "date",
          fromPlaceholder: "From date",
          toPlaceholder: "To date",
        },
        cell: (value) => <span>{formatDateTime(value)}</span>,
      },
      {
        id: "accountNo",
        header: "Account No",
        accessorKey: "accountNo",
        filter: { type: "text", placeholder: "Account number" },
        enableGlobalFilter: true,
      },
      {
        id: "debitMsisdn",
        header: "Debit MSISDN",
        accessorKey: "debitMsisdn",
        filter: { type: "text", placeholder: "Debit MSISDN" },
        enableGlobalFilter: true,
      },
      {
        id: "creditShortCode",
        header: "Credit Short Code",
        accessorKey: "creditShortCode",
      },
      {
        id: "trxId",
        header: "TrxID",
        accessorKey: "trxId",
        filter: { type: "text", placeholder: "Transaction ID" },
        enableGlobalFilter: true,
      },
      {
        id: "transactionStatus",
        header: "Transaction Status",
        accessorKey: "transactionStatus",
      },
      {
        id: "currency",
        header: "Currency",
        accessorKey: "currency",
        align: "center",
      },
      {
        id: "amount",
        header: "Amount",
        accessorKey: "amount",
        cell: (value) => <span>{formatCurrency(Number(value ?? 0))}</span>,
        align: "right",
      },
    ],
    []
  );

  return (
    <div className={styles.page}>
      <Card>
        <div className={styles.header}>
          <h1 className={styles.title}>Upay Transaction</h1>
          <p className={styles.subtitle}>
            Monitor Upay wallet transactions and their current status.
          </p>
        </div>

        <DataTable
          columns={columns}
          data={transactions}
          pageSizeOptions={[5, 10, 25]}
          initialPageSize={5}
          globalSearchPlaceholder="Search by account, MSISDN, or transaction ID"
          emptyState="No Upay transactions found for the selected filters."
        />
      </Card>
    </div>
  );
}

export default UpayTransactionsPage;
